export const environment = {
  production: true,
  ambiente:'(PROD GCP)',
  mailPath:'./ApiMail/contacto.php',
  host:'https://chatcris-backend-python-thv4klurva-ue.a.run.app',
  host2:'https://chatcris-bot-backend-python-thv4klurva-ue.a.run.app'
};